export const PSEUDO_LANGUAGE = "en-XA";
const PLAIN = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
const ACCENTED = "\xE0\u0180\xE7\xF0\xE9\u0192\u011D\u0125\xEE\u0135\u0137\u013C\u0271\xF1\xF6\xFE\u01EB\u0155\u0161\u0163\xFB\u1E7D\u0175\u1E8B\xFD\u017E\xC0\xDF\xC7\xD0\xC9\u0191\u011C\u0124\xCE\u0134\u0136\u013B\u1E40\xD1\xD6\xDE\u01EA\u0154\u0160\u0162\xDB\u1E7C\u0174\u1E8A\xDD\u017D";
const ACCENTED_BY_LETTER = Object.fromEntries([...PLAIN].map((letter, index) => [letter, [...ACCENTED][index]]));
const EXPANSION = 0.3;
const pseudoLocalize = (text) => {
  const accented = [...text].map((char) => {
    var _a;
    return (_a = ACCENTED_BY_LETTER[char]) != null ? _a : char;
  }).join("");
  const padding = "~".repeat(Math.ceil(text.length * EXPANSION));
  return `[${accented}${padding}]`;
};
export default pseudoLocalize;
